import { defineAsyncComponent, reactive, toRaw } from "vue";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { createPage } from "../../../../utils/page";
import { required, validateError } from "../../../../utils/validate";
import { createColumns } from "./haz-short-detail.section";
import i18n from "../../../../i18n";
import { Modal } from "ant-design-vue";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon.vue"));
const HazShortDetailForm = defineAsyncComponent(() => import("./HazShortDetailForm.vue"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callSearch = ({ criteria }) => store.dispatch(`resource/v1/transaction/haz/searchShortDetail`, { criteria });

export const onSearch = ({ page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereFor()], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createWhereFor = () => {
    return []
}

export const createRulesTop = ({ key }) => {
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}id`]: [required],
    };
};

export const validate = ({ props, data, refs }) => {
    const { menuContext } = props;
    const rulesTop = createRulesTop({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesTop))
        .catch(error => {
            if (tabKey) {
                menuContext.tabKey = tabKey;
            }
            validateError({ error });
            throw error;
        });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const initState = () => {
    state.manages = [];
    state.manageExtras = [];
    state.rowActions = [
        {
            visible: () => true,
            bind: { class: "btn-info", size: "small", icon: () => <CIcon file="eye.svg"></CIcon> },
            text: () => i18n.global.t("button.view"),
            showText: () => false,
            onClick: ({ record }) => {
                console.log("onClick record", record)
                Modal["info"]({
                    title: i18n.global.t("views.report.haz"),
                    content: <>
                        <HazShortDetailForm form={record}></HazShortDetailForm>
                    </>,
                    width: 800
                });
            },
        }
    ];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [],
            sort: [{ name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
});

